import { useEffect, useState, useCallback } from "react";
import HeroSection from "@/components/HeroSection";
import StatsBar from "@/components/StatsBar";
import AboutPreview from "@/components/AboutPreview";
import TrustReasons from "@/components/TrustReasons";
import RecentSales from "@/components/RecentSales";
import TestimonialsPreview from "@/components/TestimonialsPreview";
import ServiceAreas from "@/components/ServiceAreas";
import LeadCaptureSection from "@/components/LeadCaptureSection";
import CTASection from "@/components/CTASection";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const defaultTestimonials = [
  {
    id: "jacobo-belmonte",
    name: "Jacobo Belmonte",
    location: "Jurupa Valley, CA",
    text: "We've now worked with Raad not just once or twice, but three times — and that alone speaks volumes about the level of service he provides. Every experience has been outstanding.",
    rating: 5,
    date: "Mar 2026",
  },
  {
    id: "warren-k",
    name: "Warren K",
    location: "Corona, CA",
    text: "While interviewing several agents, our neighbor recommended Raad to us. He immediately distinguished himself from the rest by presenting a simple but realistic overview of the selling process.",
    rating: 5,
    date: "Mar 2026",
  },
  {
    id: "nikki-yik",
    name: "nikki yik",
    location: "Corona, CA",
    text: "Raad did an outstanding job selling my mom's house. Professional, compassionate, and highly skilled — he priced it right, marketed beautifully, negotiated expertly, and made the whole process seamless.",
    rating: 5,
    date: "Feb 2026",
  },
];

export default function HomePage() {
  const [testimonials, setTestimonials] = useState(defaultTestimonials);

  const fetchData = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/testimonials`);
      if (response.data.length > 0) {
        setTestimonials(response.data.slice(0, 3));
      }
    } catch (_err) {
      // Fallback to default testimonials - expected when no DB data exists
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <div className="page-transition" data-testid="home-page">
      <HeroSection />
      <StatsBar />
      <AboutPreview />
      <TrustReasons />
      <RecentSales />
      <TestimonialsPreview testimonials={testimonials} />
      <ServiceAreas />
      <LeadCaptureSection />
      <CTASection />
    </div>
  );
}
